import { getCustomerNameRoute } from "@slfinrtl/ui-bff-routes"
import { useCallback, useEffect, useState } from "react"
import { useCapSamlToken } from "src/hooks/cap/useCapSamlToken/useCapSamlToken"
import { useBffDynamic } from "src/hooks/useBffDynamic/useBffDynamic"

interface BusinessPartnerNameResponse {
	hasError: boolean
	value: undefined | string
}

export const useBusinessPartnerName = (businessPartnerId?: string): BusinessPartnerNameResponse | undefined => {
	const getCustomerName = useBffDynamic(getCustomerNameRoute, "inline")
	const [businessPartnerNameResponse, setBusinessPartnerNameResponse] = useState<BusinessPartnerNameResponse>()

	const onError = useCallback(() => {
		setBusinessPartnerNameResponse({ hasError: true, value: undefined })
	}, [])

	const capSamlToken = useCapSamlToken(onError, Boolean(businessPartnerId))

	useEffect(() => {
		let isCancelled = false

		async function loadCustomerName() {
			setBusinessPartnerNameResponse(undefined)
			if (businessPartnerId && capSamlToken) {
				try {
					const res = await getCustomerName({
						body: undefined,
						pathParams: { businessPartnerId },
						queryParams: { capSamlToken },
					})
					if (!isCancelled) {
						setBusinessPartnerNameResponse({
							hasError: false,
							value: res.formattedName,
						})
					}
				} catch {
					if (!isCancelled) {
						onError()
					}
				}
			}
		}

		void loadCustomerName()

		return () => {
			isCancelled = true
		}
	}, [businessPartnerId, getCustomerName, onError, capSamlToken])

	return businessPartnerNameResponse
}
